export const styles = (theme) => ({
    box: {
        fontFamily: 'var(--font-rubik)',
        backgroundColor: '#262626',
        borderRadius: '8px',
        display: 'flex',
        alignItems: 'center',
        padding: '14px 16px',
        gap: '16px',
    },

    icon: {
        height: '20px',
        width: '20px',
        flexShrink: 0,
    },

    closeIconBtn: {
        padding: '0px',
    },

    closeIcon: {
        color: '#fff',
    },

    messageContainer: {
        display: 'flex',
        alignItems: 'flex-start',
        overflow: 'hidden',
        gap: '8px',
    },

    message: {
        fontFamily: 'var(--font-rubik)',
        color: '#fff',
        fontSize: '16px',
        fontWeight: 400,
        letterSpacing: '0.01em',
        textAlign: 'left',
        textTransform: 'none',
        whiteSpace: 'normal',
        overflowWrap: 'break-word',
        lineHeight: '20px',

        '@media (max-width: 600px)': {
            fontSize: '14px',
        },
    },
});
